module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/2-8e11ce0ac3f12619c73746a261f35164.png";